export default __webpack_public_path__ + "static/media/login.efb5b18b.png";